import React, { useState, useEffect } from "react";
import './styles/evaluationsDisplay.css';
import server, { endpoints } from '../../../utils/server';
import { message } from "antd";
const EvaluationsD = ({showQ,team,selectedT,selectedE,idCycle}) => {
    const [selectedTeam, setSelectedTeam] = useState();
    const [teams, setSelectedTeams] = useState();
    const [evaluationInfo, setEvaluationInfo] = useState();

    const getEvaluation = async () => {
      try {
  
      const params = {
        id_cycle: idCycle,
      };
  
      const res = await server(endpoints.getEvaluation.route, endpoints.getEvaluation.method, params);
      const {error_message, data: evaluationInfo } = res;
      if (error_message){
        message.error(error_message);
      }else{
        setEvaluationInfo(evaluationInfo);
        
      }
      }
      catch (error) {
        message.error(error);
      }
    }

    useEffect(() => {
      setSelectedTeam(selectedT);
      setSelectedTeams(team);
      getEvaluation();
    }, [selectedT,team,selectedE, showQ]);
  
    const handleChange = (event) => {
      const selected = teams.find((t) => t.team === event.target.value);
      setSelectedTeam(selected);
    };
    return(
      <>
       <select
        id="dropdown"
        value={selectedTeam?.team || ""}
        onChange={handleChange}
        style={{
          padding: "8px",
          borderRadius: "5px",
          border: "1px solid #ccc",
          fontSize: "16px",
        }}
      >
        <option value="" disabled>
          -- Selecciona una opción --
        </option>
      {teams && teams?.length>0 ? (teams.map((t)=>(
      
        <option key={t.team} value={t.team}>{t.team}</option>
       
          ))):(
            <option value="" disabled>
              No tienes equipos
            </option>
          )}
          </select>
          {selectedTeam?.evaluations?.length > 0 ? (
        selectedTeam.evaluations.map((t, index) => {
          const evalInfo = evaluationInfo?.find((e) => e.name === t.name);
          return(
          <div
            className="evaluationsDisplay-card-container"
            onClick={()=>{showQ(t,selectedTeam)}}
            key={index}
          >
            <div className="evaluationsDisplay-card-content">
              <div className="evaluationsDisplay-card-title">
                <strong>{t.name}</strong>
                <span className="evaluationsDisplay-card-date"> {evalInfo ? evalInfo.start_date.split('T')[0] : "Sin fecha de inicio"}</span>
        </div>
        <p className="evaluationsDisplay-card-subtitle">Se vence el {evalInfo ? evalInfo.end_date.split('T')[0] : "Sin fecha de vencimiento"}</p>
          
            </div>
            <div className="evaluationsDisplay-card-icon">
              <span>&#x276F;</span>
            </div>
          </div>
          )
})
      ) : (
        <div className="evaluationsDisplay-card-container">
          No tienes evaluaciones pendientes
        </div>
      )}
    </>    
    )
  }
export default EvaluationsD;